// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";
import { connect } from "react-redux";

import { withRouter } from "view/reactrouterinterceptor";
import {
  ISiteBarDispatch,
  ISiteBarProps,
  SiteBarComponent,
  mapStateToProps as siteBarProps,
} from "./SiteBar";
import { IState } from "states/states";
import ControlCircuitSelect from "./ControlCircuitSelect";

import "./SiteBar.scss";

const mapStateToProps = (state: IState) => {
  const props: ISiteBarProps = {
    ...siteBarProps(state),
  };

  return props;
};

class MonitorSiteBarComponent extends SiteBarComponent<ISiteBarProps & ISiteBarDispatch> {
  public override renderSelectionButtons() {
    return (
      <>
        <ControlCircuitSelect className="btn-header" />
      </>
    );
  }
}

export default connect(mapStateToProps)(withRouter(MonitorSiteBarComponent));
